import { Component } from '@angular/core';
import { MenuController } from '@ionic/angular';

@Component({
  selector: 'app-splash',
  templateUrl: './splash.component.html',
  styleUrls: ['./splash.component.scss'],
  standalone: false,
})
export class SplashComponent {
  public showSplash = true;
  public hiding = false;
constructor(public menuCtrl: MenuController) {

}
public ngOnInit() {
  // Splash is now hidden by parent via hideSplash()
}
 public hideSplash(): void {
    this.hiding = true;
  }

  public onFadeComplete(): void {
    this.showSplash = false;
  }
  public ionViewWillEnter() {
    this.menuCtrl.enable(false);
  }

  public ionViewWillUnload() {
    this.menuCtrl.enable(true);
  }
}
